import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { Menu } from "../../../components/menu-consultas";

export const LayoutConsultaMandado: React.FC = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <MUI.Stack
      pt={[2, 0]}
      flexDirection={["column", "row"]}
      width="100%"
      sx={{
        // Desktop: manter altura fixa original (80vh)
        // Mobile: usar altura mínima dinâmica
        height: { xs: "auto", sm: "80vh" },
        minHeight: { xs: "100vh", sm: "80vh" },
        // Mobile: controlar overflow para scroll suave
        overflowX: "hidden",
        overflowY: { xs: "auto", sm: "hidden" },
      }}
    >
      <Menu
        titulo="Consulta mandado"
        menu={[
          // {
          //   to: "/consulta-mandado-pesquisa-nominal",
          //   label: "Pesquisa nominal",
          //   icon: <Icon.PersonSearch sx={{ color: "white" }} />,
          //   isSelected: pathname === "/consulta-mandado-pesquisa-nominal",
          // },
          {
            to: "/consulta-mandado-facial",
            // label: "Pesquisa facial",
            label: "Pesquisa Mandado",
            icon: <Icon.CameraFront sx={{ color: "white" }} />,
            isSelected: pathname === "/consulta-mandado-facial",
          },
          {
            to: "/pagina-inicial",
            icon: <Icon.KeyboardReturn sx={{ color: "white" }} />,
            label: "Voltar página inicial",
          },
        ]}
      />
      <MUI.Stack
        flex={1}
        padding={2}
        gap={1}
        sx={{
          // Desktop: manter overflow="auto" original
          // Mobile: melhor controle de overflow
          overflow: { xs: "visible", sm: "auto" },
          overflowY: { xs: "auto", sm: "auto" },
          overflowX: "hidden",
          maxWidth: "100%",
          // Mobile: altura dinâmica, Desktop: automático
          minHeight: { xs: "calc(100vh - 200px)", sm: "auto" },
        }}
      >
        {children}
      </MUI.Stack>
    </MUI.Stack>
  );
};
